module.exports = function() {
  return new Worker(__webpack_public_path__ + "440638cecf21066677fd.worker.js");
};